'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('./styleInject.js');

var css_248z = ".PanelHeader-module_panelHeader__aZnFy{background-color:#302d35;box-sizing:border-box;color:#fff;font-size:.875rem;line-height:1.25rem;margin:0;padding:.625rem 0 .625rem 1.5rem;text-align:left;width:100%}";
var styles = {"panelHeader":"PanelHeader-module_panelHeader__aZnFy"};
styleInject["default"](css_248z, '5a8710d7-bdf1-4c55-bf15-868f09efafa4');

exports["default"] = styles;
